export default function (arr,page){
    window.$matomo.deleteCustomVariables('page');
    window.$matomo.setCustomUrl(location.href)
    window.$matomo.setSiteId(40);
    arr.forEach((element,index) => {
        window.$matomo.setCustomVariable(index+1,element.key,element.value,'page');
    });
    window.$matomo.trackPageView(page);
}